import Papa from 'papaparse';

/** Downloads rows as a CSV file (client-side, no API call). */
export const downloadCsv = (filename: string, rows: Record<string, unknown>[], fields: string[]) => {
  const csv = Papa.unparse({ fields, data: rows.map((row) => fields.map((field) => row[field] ?? '')) });
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
